export interface LoginRequest {
  employeeCode: string;
  password: string;
}

export const EmptyLoginRequest: LoginRequest = {
  employeeCode: '',
  password: '',
};
